import React, { FunctionComponent } from 'react';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { ResponseState } from 'reviews2/feed/review-yeti/reply/ReviewReply.types';

interface Props {
    reply: any;
}

export const ReplyPublished: FunctionComponent<Props> = ({ reply }) => {
    const { t } = useTranslation('reviews2');

    if (![ResponseState.Published].includes(reply.responseState)) {
        return null;
    }

    return (
        <span className="reply-success">
            <OverlayTrigger overlay={<Tooltip id={reply.document_id}>{t('PUBLISHED_TOOLTIP')}</Tooltip>}>
                <i className="icon-check-circle" />
            </OverlayTrigger>
            {t('REPLY_PUBLISHED')}{' '}
        </span>
    );
};
